export default "__VITE_ASSET__DKhOjYKd__"